import React from 'react';
import './SecondaryButton.scss';
import { Link } from 'react-router-dom';

const SecondaryButton = props => {
  return (
    <Link
      className={'btn secondary-button btn-' + props.size}
      to={props.to}
      disabled={props.disabled}
    >
      {props.title}
    </Link>
  );
};

export default SecondaryButton;



// WEBPACK FOOTER //
// ./src/Component/SecondaryButton.js